import { render, staticRenderFns } from "./ElementsTreeComponent.vue?vue&type=template&id=a4461164"
import script from "./ElementsTreeComponent.vue?vue&type=script&lang=js"
export * from "./ElementsTreeComponent.vue?vue&type=script&lang=js"
import style0 from "./ElementsTreeComponent.vue?vue&type=style&index=0&id=a4461164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports